window.$setAttrLoadingLazy = function(tag = "img") {
  setTimeout(() => {
    const findTag = document.getElementsByTagName(tag);

    for (const item of findTag) {
      if (!item.getAttribute("loading")) item.setAttribute("loading", "lazy");
    }
  }, 800);
};
